"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = void 0;

var color = function color() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var targetColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var colorProp = theme["bColor".concat(targetColor)] || targetColor;
  return colorProp;
};

exports.color = color;